import AddonService from '@/modules/addon/services/AddonService'
import FloorplanService from '@/modules/floorplan/services/FloorplanService'
import GuestService from '@/modules/guest/services/GuestService'
import GuestReservationService from '@/modules/guestUi/services/GuestReservationService'
import MailchimpService from '@/modules/mailchimp/services/MailchimpService'
import NotificationTemplateService from '@/modules/notification/services/NotificationTemplateService'
import PerformanceService from '@/modules/performance/services/PerformanceService'
import CouponService from '@/modules/promoCode/services/CouponService'
import PromoCodeService from '@/modules/promoCode/services/PromoCodeService'
import AccountingService from '@/modules/report/services/AccountingService'
import ReportService from '@/modules/report/services/ReportService'
import ReservationService from '@/modules/reservation/services/ReservationService'
import ResidencyService from '@/modules/residency/services/ResidencyService'
import SettingService from '@/modules/setting/services/SettingService'
import ShowService from '@/modules/show/services/ShowService'
import SeatingTimeService from '@/modules/showtime/services/SeatingTimeService'
import ShowtimeService from '@/modules/showtime/services/ShowtimeService'
import StripeService from '@/modules/stripe/services/StripeService'
import UserService from '@/modules/user/services/UserService'

export const getSettings = SettingService.get
export const updateSettings = SettingService.update
export const getAddOns = AddonService.fetchAll
export const updateAllAddOns = AddonService.updateAll
export const getFloorPlans = FloorplanService.fetchAll
export const addFloorPlan = FloorplanService.create
export const addFloorPlanDetailed = FloorplanService.createDetailed
export const deleteFloorPlan = FloorplanService.delete
export const updateFloorPlanDetailed = FloorplanService.updateDetailed
export const duplicateFloorPlan = FloorplanService.duplicate
export const getShowTimes = ShowtimeService.fetchAll
export const addShowTime = ShowtimeService.create
export const updateShowTime = ShowtimeService.update
export const updateAllShowTimes = ShowtimeService.updateAll
export const deleteShowTime = ShowtimeService.delete
export const addSeatingTime = SeatingTimeService.create
export const updateSeatingTime = SeatingTimeService.update
export const getShow = ShowService.fetchOne
export const getShows = ShowService.fetchAll
export const addShow = ShowService.create
export const updateShow = ShowService.update
export const updateShowImage = ShowService.updateImage
export const updateShowImagePosition = ShowService.updateImagePosition
export const updateShowCrops = ShowService.updateCrops
export const deleteShow = ShowService.delete
export const duplicateShow = ShowService.duplicate
export const getPerformances = PerformanceService.fetchAll
export const getPerformanceReports = PerformanceService.fetchReports
export const getPerformance = PerformanceService.fetchOne
export const addPerformance = PerformanceService.create
export const updatePerformance = PerformanceService.update
export const updatePerformanceDetailed = PerformanceService.updateDetailed
export const deletePerformance = PerformanceService.delete
export const getPerformanceReservations = PerformanceService.fetchReservations
export const sendMassEmail = PerformanceService.sendMassEmail
export const getAccountingSummary = AccountingService.getSummary
export const getSummaryReports = ReportService.getSummary
export const createReportInstance = ReportService.createInstance
export const getReportInstance = ReportService.getInstance
export const getReportInstances = ReportService.listInstances
export const createReportSchedule = ReportService.createSchedule
export const listReportSchedules = ReportService.listSchedules
export const updateReportSchedule = ReportService.updateSchedule
export const deleteReportSchedule = ReportService.deleteSchedule
export const getReservations = ReservationService.fetchAll
export const getReservation = ReservationService.fetchOne
export const getReservationsByPerformance = ReservationService.fetchByPerformance
export const addReservation = ReservationService.create
export const retryReservation = ReservationService.retry
export const updateReservation = ReservationService.update
export const paidUpdateReservation = ReservationService.updatePaid
export const payReservation = ReservationService.pay
export const refundTransaction = ReservationService.refundTransaction
export const resendConfirmationEmail = ReservationService.resendConfirmation
export const deleteReservation = ReservationService.delete
export const getReservationStatus = ReservationService.fetchStatus
export const reserveReservation = GuestReservationService.reserve
export const guestModifyReservation = GuestReservationService.modify
export const abandonReservation = GuestReservationService.abandon
export const guestInfoReservation = GuestReservationService.guestInfo
export const validatePromotionCode = PromoCodeService.validate
export const updateAllPromotionCodes = PromoCodeService.updateAll
export const getPromotionCodes = PromoCodeService.fetchAll
export const getCoupons = CouponService.fetchAll
export const searchGuests = GuestService.search
export const getGuest = GuestService.fetchOneDetailed
export const updateGuest = GuestService.update
export const mergeGuest = GuestService.merge
export const getMe = UserService.fetchMe
export const getMeOnboarding = UserService.fetchMeOnboarding
export const login = UserService.login
export const setPassword = UserService.setPassword
export const sendResetPasswordEmail = UserService.sendResetPasswordEmail
export const resetPassword = UserService.resetPassword
export const getUsers = UserService.fetchAll
export const updateAllUsers = UserService.updateAll
export const getReaders = StripeService.fetchReaders
export const cancelReaderAction = StripeService.cancelAction
export const simulatePayment = StripeService.simulatePayment
export const createResidency = ResidencyService.create
export const getResidencies = ResidencyService.fetchAll
export const updateResidency = ResidencyService.update
export const deleteResidency = ResidencyService.delete
export const getResidency = ResidencyService.fetchOnePublic
export const getMailchimpSettings = MailchimpService.fetchSettings
export const updateMailchimpSettings = MailchimpService.updateSettings
export const getMailchimpAudiences = MailchimpService.fetchAudiences
export const disconnectMailchimp = MailchimpService.disconnect
export const createTemplate = MailchimpService.createTemplate
export const getTemplates = NotificationTemplateService.fetchAll
export const updateTemplate = NotificationTemplateService.update
